export default __webpack_public_path__ + "static/media/cycloneofsteel4.3c14edd0.png";